module.exports = window.rails_asset_host + "/packs/media/src/Login/assets/images/PF4DownstreamBG-99732cadf05f0e7f1292ddf4145c3136.svg";